import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import swal from "sweetalert";
import { useDispatch, useSelector } from 'react-redux';
import { IghandleLogoutAndReLogin } from '../../store/instagram/instagramThunk';
import { resetigReLoginMessage } from '../../store/instagram/instagramSlice';
import { FbhandleLogoutAndReLogin } from '../../store/facebook/facebookThunk';
import { toast } from 'react-toastify';

const BASE_URL = process.env.REACT_APP_BASE_URL;

console.log(process.env.REACT_APP_BASE_URL, "process.env.REACT_APP_BASE_URLprocess.env.REACT_APP_BASE_URL")

const FacebookError = () => {
    const [error, setError] = useState('');
    const [userId, setUserId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { igReLoginMessage } = useSelector((state) => state.instagram);

    const getQueryParams = () => {
        const urlParams = new URLSearchParams(window.location.search);
        setError(urlParams.get('error'));
        setUserId(urlParams.get('userId'));
    };

    useEffect(() => {
        getQueryParams(); // Get the parameters on component load
    }, []);

    useEffect(() => {
        if (igReLoginMessage) {
            toast.error("Logout Successful")
            navigate('/Settings');
            dispatch(resetigReLoginMessage())
        }
    }, [igReLoginMessage, navigate]);

    const handleLogoutAndReLogin = async () => {
        if (userId) {
            setIsLoading(true);
            try {
                const response = await dispatch(FbhandleLogoutAndReLogin(userId));
                if (response.meta.requestStatus === 'fulfilled') {
                    // Handle successful logout and relink, e.g., show a success message
                    toast.success("Success!", "You have successfully logged out and can now re-link your account.", "success");
                    navigate('/Settings');
                } else {
                    // Handle error case
                    toast.error("Error!", "There was an error logging out. Please try again.", "error");
                }
            } catch (error) {
                console.error("Logout and relink error:", error);
                toast.error("Error!", "There was an error logging out. Please try again.", "error");
            } finally {
                setIsLoading(false);
            }
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 transform transition-all duration-300 ">
                {/* Facebook Icon */}
                <div className="flex justify-center mb-6">
                    <div className="w-16 h-16 bg-[#1877F2] rounded-2xl flex items-center justify-center shadow-lg">
                        <svg className="w-9 h-9 text-white" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                        </svg>
                    </div>
                </div>

                {/* Title */}
                <h2 className="text-2xl font-bold text-gray-800 text-center mb-2">
                    Facebook Authentication
                </h2>
                <div className="flex items-center justify-center mb-6">
                    <div className="w-12 h-1 bg-red-500 rounded-full"></div>
                    <span className="mx-2 text-red-500 font-semibold">Error</span>
                    <div className="w-12 h-1 bg-red-500 rounded-full"></div>
                </div>

                {/* Error Message */}
                {error && (
                    <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6 rounded-r-lg">
                        <div className="flex items-center">
                            <svg className="w-5 h-5 text-red-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                            </svg>
                            <p className="text-red-700 text-sm font-medium">{error}</p>
                        </div>
                    </div>
                )}

                {/* Description */}
                <div className="text-center mb-8">
                    <p className="text-gray-600 leading-relaxed">
                        We encountered an issue with your Facebook account authentication. 
                        Would you like to log out and re-link it to your current account?
                    </p>
                </div>

                {/* Action Buttons */}
                <div className="space-y-4">
                    <button 
                        className={`w-full py-3 px-6 rounded-xl font-semibold text-white transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-blue-300 ${
                            isLoading 
                                ? 'bg-gray-400 cursor-not-allowed' 
                                : 'bg-[#1877F2] hover:bg-[#166FE5] shadow-lg hover:shadow-xl'
                        }`}
                        onClick={handleLogoutAndReLogin}
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <div className="flex items-center justify-center">
                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Processing...
                            </div>
                        ) : (
                            <>
                                <svg className="w-5 h-5 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                                Yes, log out and re-link
                            </>
                        )}
                    </button>
                    
                    <button 
                        className="w-full py-3 px-6 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-gray-300 border border-gray-200"
                        onClick={() => navigate('/Settings')}
                        disabled={isLoading}
                    >
                        <svg className="w-5 h-5 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        Cancel
                    </button>
                </div>

                {/* Footer */}
                <div className="mt-8 pt-6 border-t border-gray-100">
                    <p className="text-xs text-gray-500 text-center">
                        Having trouble? Contact our support team for assistance.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default FacebookError;